<template>
  <div id="app" :key="key" class="min-h-[100vh] overflow-hidden">
    <Application />
  </div>
</template>

<script setup>
import Application from "./main.vue";
import { computed, watch, ref, onMounted } from "vue";
import { storeApp } from "./store";

const showMenu = computed(() => storeApp.getters.getMenuState);
const key = ref(0);

watch(
  () => showMenu.value,
  (newVal) => {
    if (newVal) {
      key.value += 1;
    }
  },
  { immediate: true }
);

onMounted(() => {
  checkAppVersion();
});

async function checkAppVersion() {
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      cache: "no-store",
    });

    const data = await response.json();
    const currentVersion = localStorage.getItem("app_version");

    if (!currentVersion) {
      localStorage.setItem("app_version", data.version);
      return;
    }

    if (currentVersion !== data.version) {
      localStorage.setItem("app_version", data.version);

      if ("caches" in window) {
        const cacheKeys = await caches.keys();
        await Promise.all(cacheKeys.map((key) => caches.delete(key)));
      }

      window.location.reload();
    }
  } catch (error) {
    console.error("Erro ao verificar versão do app:", error);
  }
}
</script>

<style lang="scss">
#app {
  max-height: 100vh;
  font-family: Circular, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

  ::-webkit-scrollbar {
    width: 4px;
    height: 1px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #888888ab;
    border-radius: 6px;
  }

  ::-webkit-scrollbar-track {
    background-color: #f1f1f1;
    border-radius: 6px;
  }
}
</style>
